<template>
  <v-file-input
    v-model="filename"
    accept=".dat"
    label="File memory (fixed length mapping 13 + 5)"
    show-size
    outlined
    dense
    multiple
    :disabled="disabled"
    prepend-icon=""
    prepend-inner-icon="$file"
    @change="onChange"
  ></v-file-input>
</template>

<script>
import * as _ from 'lodash'
import * as dot from 'dot-object'

  export default {
    props: {
      disabled: Boolean,
      resetFile: Number
    },
    data: () => ({
      filename: null,
      isLoading: false,
      nomeFile: '',
      showImporta: false,
      dati: null
    }),
    watch: {
      resetFile() {
        this.filename = null
      }
    },
    methods: {
      str2ab(str) {
        var buf = new ArrayBuffer(str.length)
        var bufView = new Uint8Array(buf)
        for (var i = 0, strLen = str.length; i < strLen; i++) {
          bufView[i] = str.charCodeAt(i)
        }
        return buf
      },
      onChange(file) {
        if ((file instanceof Array) && file.length > 1) {
          this.fileArray(file)
        } else {
          this.fileSingolo(file[0])
        }
      },
      fileArray(arrFile) {
        for (let file of arrFile) {
          this.isLoading = true
          const nomeFile = file.name
          const fr = new FileReader()
          fr.readAsDataURL(file)
          fr.addEventListener('load', () => {
            const content = fr.result
            const data = atob(content.substring(content.indexOf(',') + 1))
            var fileData = data.split('\r\n')
            var dati
            try {
              dati = fileData.filter(x => x).map(x => { return { barcode: String(x.slice(0, 13)), quantita: parseInt(x.substr(-5)) }})
            } catch(err) {
              console.log(err)
            }
            this.afterReadArray(nomeFile, dati)
            this.isLoading = false
          })
        }
      },      
      fileSingolo(file) {
        if (!file) {
          this.dati = null
          this.$emit('onLoaded', null)
          return
        }
        this.isLoading = true
        const nomeFile = file.name
        const fr = new FileReader()
        fr.readAsDataURL(file)
        fr.addEventListener('load', () => {
          this.nomeFile = nomeFile
          const content = fr.result
          const data = atob(content.substring(content.indexOf(',') + 1))
          var fileData = data.split('\r\n')
          try {
            this.dati = fileData.filter(x => x).map(x => { return { barcode: String(x.slice(0, 13)), quantita: parseInt(x.substr(-5)) }})
          } catch(err) {
            console.log(err)
          }
          this.afterRead()
          this.isLoading = false
        })
      },
      afterRead() {
        let dati = this.dati
        this.isLoading = false
        this.showImporta = true
        const datiResult = {
          nomeFile: this.nomeFile,
          tipoFile: 'memory',
          datiRaw: dati,
          intestazioniRaw: [
            { key: 'barcode', value:'BARCODE' },
            { key: 'quantita', value:'QUANTITA' }
          ]
        }   
        this.$emit('onLoaded', datiResult)
      },
      afterReadArray(nomeFile, dati) {
        const datiResult = {
          nomeFile: nomeFile,
          tipoFile: 'memory',
          datiRaw: dati,
          intestazioniRaw: [
            { key: 'barcode', value:'BARCODE' },
            { key: 'quantita', value:'QUANTITA' }
          ]
        }
        this.$emit('onLoadedArray', datiResult)
      },        
      async asyncSome (arr, predicate) {
        for (const e of arr) {
          if (await predicate(e)) return true
        }
        return false
      }
    }
  }
</script>
